
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-06874f6c&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GridComponentFactory.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./GridComponentFactory.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-06874f6c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./GridComponentFactory.vue"),
  /* scopeId */
  "data-v-06874f6c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/GridComponentFactory.vue
// module id = 85
// module chunks = 2